import React from 'react'
// import { withRouter } from "react-router-dom";
import { StyledImage } from './Image.styled'
const Image = ({ src, alt, size, position, bgPosition, zIndex, animation, shape, width, height, bgColor }) => {
  return (
    <>
      {src && (
        <StyledImage
          src={'image/' + src}
          alt={alt}
          title={alt}
          size={size}
          position={position}
          bgPosition={bgPosition}
          zIndex={zIndex}
          animation={animation}
          shape={shape}
          width={width}
          height={height}
          bgColor={bgColor}
        />
      )}
    </>
  )
}

export default Image
